<template>
    <div class="bg-[#EDE2D6]">
        <div class="site-frame">
            <div class="container py-5.5">
                <div class="flex flex-col items-center justify-center gap-y-2 md:flex-row md:gap-y-0">
                    <div class="flex flex-wrap items-center justify-center gap-2.5">
                        <slot></slot>
                    </div>

                    <div><CountdownTimer :end="end" /></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import CountdownTimer from './CountdownTimer.vue';

defineProps({ end: { type: String, required: true } });
</script>
